import { render } from "./ModalPlayerProfile.vue?vue&type=template&id=69ffaf5c&scoped=true"
import script from "./ModalPlayerProfile.vue?vue&type=script&lang=js"
export * from "./ModalPlayerProfile.vue?vue&type=script&lang=js"

import "./ModalPlayerProfile.vue?vue&type=style&index=0&id=69ffaf5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69ffaf5c"

export default script